<ul class="contextmenu" [ngStyle]="{'left.px': x, 'top.px': y}" style="cursor: pointer;">
    <li>Delete</li>
    <li>Update</li>
</ul>